'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useState } from 'react';

import { kycPopupBunja } from '@web/app/[locale]/(web)/_main-page/sections/PopUpManager/KycPopup/bunja';

import KycPopup from './KycPopup';
import RewardHubPopUp from './RewardHubPopup';
import { useRewardHubPopUp } from './RewardHubPopup/useRewardHubPopUp';

/**
 * 메인 페이지에서 팝업 노출 순서를 관리합니다. 신규 팝업이 추가되는 경우 아래에 우선 순위에 맞게 넣어주세요
 *
 * 1. Kyc Popup
 * 2. Reward hub Popup
 * */
const PopUpManager = () => {
  // 간혹 상위에서 리렌더링 되면서 페이지 새로고침이나 재진입 하지 않아도 다음 팝업이 열리는 현상을 방지.
  const [isPopupClosedOnce, setIsPopupClosedOnce] = useState(false);

  const { isShowKycPopupAtom } = useBunja(kycPopupBunja);
  const { isShowRewardHubAlert } = useRewardHubPopUp();

  const isShowKycPopup = useAtomValue(isShowKycPopupAtom);

  const handleClosePopup = () => {
    setIsPopupClosedOnce(false);
  };

  if (isPopupClosedOnce) return null;

  if (isShowKycPopup) return <KycPopup onClose={handleClosePopup} />;
  if (isShowRewardHubAlert) return <RewardHubPopUp onClose={handleClosePopup} />;
  return null;
};

export default PopUpManager;
